export type StatusColors =
  | "red"
  | "brand"
  | "yellow"
  | "redDark"
  | "yellowDark"
  | "brandDark";

export type FormStatusColors = {
  [color in StatusColors]: {
    backgroundColor: string;
    textColor: string;
  };
};

export const FormStatusColorMap: FormStatusColors = {
  red: {
    backgroundColor: "#FFF5F5",
    textColor: "#C53030",
  },
  yellow: {
    backgroundColor: "#FFFFF0",
    textColor: "#B7791F",
  },
  brand: {
    backgroundColor: "#f2f6fa",
    textColor: "#015498",
  },
  redDark: {
    backgroundColor: "#0f172a",
    textColor: "#F56565",
  },
  yellowDark: {
    backgroundColor: "#0f172a",
    textColor: "#e2ab20",
  },
  brandDark: {
    backgroundColor: "#0f172a",
    textColor: "#7ABEF5",
  },
};
